import { WidgetExternalApplicationType } from '../../../../types/widget';
import ExternalApplicationItem from '../components/ExternalApplicationItem';
import ExternalApplicationForm from '../configuration/ExternalApplicationForm';
import { ExternalApplicationDetails, ExternalApplicationType } from '../types/externalApplication';
import { FormFieldEnum, SpecificFieldsType } from '../types/form';

type CecuritySpecificType = {
	instance: string;
};

type CecurityFormProps = {
	application: WidgetExternalApplicationType;
	isNew: boolean;
	onSubmit: (application: WidgetExternalApplicationType) => void;
	onRemove: (application: WidgetExternalApplicationType) => void;
};

export const CecurityForm = ({ application, isNew, onSubmit, onRemove }: CecurityFormProps) => {
	const { key, specific } = application;
	const jsonSpecific = specific ? (JSON.parse(specific) as CecuritySpecificType) : undefined;
	const { instance: initialInstance } = jsonSpecific ?? {};

	const specificFields: SpecificFieldsType[] = [
		{
			key,
			name: 'instance',
			type: FormFieldEnum.TEXTFIELD,
			value: initialInstance,
			description: "Instance de l'application fournie par Cecurity.",
			label: 'Instance',
			rules: {
				required: true,
			},
		},
	];

	return (
		<ExternalApplicationForm
			application={application}
			isNew={isNew}
			specificFields={specificFields}
			onSubmit={onSubmit}
			onRemove={onRemove}
		/>
	);
};

const Cecurity = ({ name }: ExternalApplicationType) => (
	<ExternalApplicationItem name={name} imageSrc="/widgets/images/cecurity-logo.png" />
);

export const getDetails = ({
	name,
	specific,
}: Pick<ExternalApplicationType, 'name' | 'specific'>): ExternalApplicationDetails => {
	const jsonSpecific = specific ? (JSON.parse(specific) as CecuritySpecificType) : undefined;
	const { instance } = jsonSpecific ?? {};

	if (!instance) {
		throw new Error('The Cecurity app instance is missing.');
	}

	return {
		name,
		url: `https://${instance}.cecurity.com/debut.aspx`,
		component: <Cecurity name={name} />,
	};
};
